import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { PageInfoService } from '../layouts/page-info.service';
import { AuthenticationService } from '../authentication/authentication.service';
import { QuotingService } from '../quoting/quoting.service';
import { GrantService } from '../authentication/grant.service';

/**
 * This component logs a user out of the system.
 */
@Component({
	selector: 'cc-logout',
	templateUrl: './logout.component.html',
	styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {

// #region [ Constructor ]

	constructor(
		private _PageInfoService: PageInfoService,
		private _AuthenticationService: AuthenticationService,
		private _Router: Router,
		private _QuoteService: QuotingService,
		private _GrantService: GrantService
	) { }

// #region [ Implemented Methods ]

	/**
	 * Component initialization.
	 */
	ngOnInit() {
		this._PageInfoService.PageTitle = "Crown Connect";
		this._PageInfoService.PageDescription = "";
		this._PageInfoService.ShowHeaderHelpPanel = this._PageInfoService.ShowHeaderUserPanel = false;

		this._AuthenticationService.Logout()
			.then(() => {
				this._QuoteService.ClearState();
				this._GrantService.ClearState();
				this._Router.navigate(['/login']);
			});
	}

}